import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Download, Search } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { inputCls } from "@/components/register/Fields";
import { PageHead } from "@/pages/admin/AdminLayout";

const GROUPS = [["", "All groups"], ["U11", "U11 Mixed"], ["U13", "U13 Boys"], ["U15", "U15 Boys"], ["GIRLS", "Girls Only"]];
const STATUSES = [["", "All"], ["confirmed", "Paid"], ["unpaid", "Unpaid"], ["pending", "In checkout"], ["refunded", "Refunded"]];
const EXPORT = `${process.env.REACT_APP_BACKEND_URL}/api/admin/export`;

const LABELS = { confirmed: "Paid", unpaid: "Unpaid", pending: "In checkout" };

export const StatusPill = ({ s }) => {
  const c = { confirmed: "bg-[var(--accent)]/15 text-[var(--accent)]", pending: "bg-blue-500/15 text-blue-300", unpaid: "bg-red-500/15 text-red-300", refunded: "bg-orange-500/15 text-orange-300" }[s] || "bg-white/10 text-slate-400";
  return <span data-testid="status-pill" className={`px-2.5 py-1 rounded-full text-xs font-medium capitalize ${c}`}>{LABELS[s] || s}</span>;
};

export default function Players() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [f, setF] = useState({ q: "", group: "", status: "" });
  const isAdmin = user.role !== "coach";
  useEffect(() => {
    const t = setTimeout(() => api.get("/admin/registrations", { params: f }).then((r) => setRows(r.data)), 250);
    return () => clearTimeout(t);
  }, [f]);

  return (
    <div data-testid="admin-players">
      <PageHead title={`Players (${rows.length})`}>
        {isAdmin && <a href={`${EXPORT}/registrations.csv`} className="btn-ghost !py-2.5 !px-4 text-sm" data-testid="export-registrations"><Download size={14} />Players CSV</a>}
        {isAdmin && <a href={`${EXPORT}/tshirts.csv`} className="btn-ghost !py-2.5 !px-4 text-sm" data-testid="export-tshirts"><Download size={14} />T-shirt sizes</a>}
      </PageHead>
      <div className="grid sm:grid-cols-3 gap-3 mb-6">
        <div className="relative"><Search size={16} className="absolute left-4 top-4 text-slate-500" /><input data-testid="players-search" placeholder="Name, reg number, parent…" className={`${inputCls} pl-11`} value={f.q} onChange={(e) => setF({ ...f, q: e.target.value })} /></div>
        <select data-testid="players-filter-group" className={inputCls} value={f.group} onChange={(e) => setF({ ...f, group: e.target.value })}>{GROUPS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select>
        <select data-testid="players-filter-status" className={inputCls} value={f.status} onChange={(e) => setF({ ...f, status: e.target.value })}>{STATUSES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select>
      </div>
      <div className="rounded-2xl border border-white/10 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-[11px] font-mono-epl uppercase tracking-wider text-slate-500 border-b border-white/10">
            <tr>{["Reg #", "Player", "Group", "Size", "Payment", ...(isAdmin ? ["Parent"] : [])].map((h) => <th key={h} className="px-4 py-3 font-medium">{h}</th>)}</tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} data-testid={`player-row-${r.id}`} onClick={() => isAdmin && navigate(`/admin/players/${r.id}`)} className={`border-b border-white/5 ${isAdmin ? "cursor-pointer hover:bg-white/[0.04]" : ""}`}>
                <td className="px-4 py-3 font-mono-epl text-xs">{r.reg_number || "—"}</td>
                <td className="px-4 py-3 font-medium">{r.first_name} {r.last_name}</td>
                <td className="px-4 py-3">{r.group_name}</td>
                <td className="px-4 py-3">{r.tshirt_size}</td>
                <td className="px-4 py-3"><StatusPill s={r.status} /></td>
                {isAdmin && <td className="px-4 py-3 text-slate-400">{r.parent_name}<br /><span className="text-xs">{r.parent_email}</span></td>}
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={6} className="px-4 py-10 text-center text-slate-500">No players found</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
